export const GET_COLORS = 'colors/GET_COLORS';
export const GET_COLORS_SUCCESS = 'colors/GET_COLORS_SUCCESS';
export const GET_COLORS_ERROR = 'colors/GET_COLORS_ERROR';
